export function homePathForRole(role) {
  if (role === "admin") return "/admin";
  if (role === "reseller") return "/reseller";
  return "/dashboard";
}
